import createIcon from '../../createIcon';

/**
 * @component @name BusinessCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgN0gxNlY1TDE0IDNIMTBMOCA1VjdINEMyLjkgNyAyIDcuOSAyIDlWMTRDMiAxNC43NSAyLjQgMTUuMzggMyAxNS43M1YxOUMzIDIwLjExIDMuODkgMjEgNSAyMUgxOUMyMC4xMSAyMSAyMSAyMC4xMSAyMSAxOVYxNS43MkMyMS41OSAxNS4zNyAyMiAxNC43MyAyMiAxNFY5QzIyIDcuOSAyMS4xIDcgMjAgN1pNMTAgNUgxNFY3SDEwVjVaTTQgOUgyMFYxNEgxNVYxMUg5VjE0SDRWOVpNMTMgMTVIMTFWMTNIMTNWMTVaTTE5IDE5SDVWMTZIOVYxN0gxNVYxNkgxOVYxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BusinessCenter = createIcon('BusinessCenter', [
  [
    'path',
    {
      d: 'M20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V14C2 14.75 2.4 15.38 3 15.73V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15.72C21.59 15.37 22 14.73 22 14V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5ZM4 9H20V14H15V11H9V14H4V9ZM13 15H11V13H13V15ZM19 19H5V16H9V17H15V16H19V19Z',
      key: 'hqtlb1',
    },
  ],
]);

export default BusinessCenter;
